import React from "react";
import {
  Button,
  FormControl,
  InputAdornment,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import TuneIcon from "@mui/icons-material/Tune";
import { colors } from "./postventaUtils";

export default function PostventaFilters({
  searchInput,
  onSearchInputChange,
  vendedores = [],
  vendedorId,
  onVendedorChange,
  tipo,
  onTipoChange,
  estado,
  onEstadoChange,
  onClear,
}) {
  return (
    <Paper elevation={0} sx={{ p: 2, borderRadius: "10px", border: `1px solid ${colors.line}`, boxShadow: "0 12px 28px rgba(19,39,84,0.08)", mb: 2 }}>
      <Stack direction={{ xs: "column", md: "row" }} spacing={1.5} alignItems={{ xs: "stretch", md: "center" }}>
        <TextField
          size="small"
          value={searchInput}
          onChange={(event) => onSearchInputChange?.(event.target.value)}
          placeholder="Buscar por cliente, vehículo o vendedor..."
          sx={{ minWidth: { xs: "100%", md: 360 } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: colors.muted, fontSize: 18 }} />
              </InputAdornment>
            ),
          }}
        />
        <FormControl size="small" sx={{ minWidth: 190 }}>
          <Select value={vendedorId} onChange={(event) => onVendedorChange?.(event.target.value)} displayEmpty>
            <MenuItem value="TODOS">Todos los vendedores</MenuItem>
            {vendedores.map((v) => (
              <MenuItem key={v.id} value={v.id}>{v.nombre}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 170 }}>
          <Select value={tipo} onChange={(event) => onTipoChange?.(event.target.value)} displayEmpty>
            <MenuItem value="TODOS">Todos los tipos</MenuItem>
            <MenuItem value="CONTADO">Contado</MenuItem>
            <MenuItem value="FINANCIACION">Financiación</MenuItem>
            <MenuItem value="ENTREGA">Entrega</MenuItem>
            <MenuItem value="MIXTO">Mixto</MenuItem>
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 170 }}>
          <Select value={estado} onChange={(event) => onEstadoChange?.(event.target.value)} displayEmpty>
            <MenuItem value="TODOS">Todos los estados</MenuItem>
            <MenuItem value="EN_ESPERA">En espera</MenuItem>
            <MenuItem value="ENTREGADO">Entregado</MenuItem>
          </Select>
        </FormControl>
        <Button variant="outlined" startIcon={<TuneIcon />} onClick={onClear} sx={{ minHeight: 38, borderRadius: "8px", fontWeight: 800 }}>
          Limpiar filtros
        </Button>
      </Stack>
    </Paper>
  );
}
